export const checkForFilledCvSections = (cvInformation) => {
    const { profileSummary, profileInformation, ...rest } = cvInformation;

    return Object.values(rest).some(value => value?.length > 0);
};
